module.exports = __webpack_public_path__ + "assets/img/ImproveLevel.dbc269c3.jpg";